import {RootStore} from "./rootStore";
import {action, observable, computed, makeObservable, runInAction} from "mobx";
import {ISubject} from '../models/subject';

export default class SubjectStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      subjects: observable,
      chosenSubjects: observable,
      setSubjects: action,
      addChosenSubject: action,
      removeChosenSubject: action,
      clearChosenSubjects: action,
      allChosenSubjects: computed,
      allSubjectsByType: computed
    });
  }

  subjects:ISubject[] = [];
  chosenSubjects:ISubject[] = [];

  setSubjects = (subjectData:ISubject[]) => {

    subjectData.reverse();
    let sortOrder = 1;
    subjectData.forEach(element => {
      element.sortOrder = sortOrder++;
    });
    this.subjects = subjectData;
  }

  addChosenSubject = (card:ISubject) => {
    runInAction(() => {
      this.chosenSubjects.push(card);
      this.chosenSubjects.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1);
    })
  }

  removeChosenSubject = (card:ISubject) => {
    this.chosenSubjects = this.chosenSubjects.filter(x => x.slug !== card.slug);
  }

  clearChosenSubjects = () => {
    this.chosenSubjects = [];
  }

  get allChosenSubjects():ISubject[] {
    if(this.chosenSubjects.length === 0) return this.subjects.filter(subject => subject.subjectType.subjectType == this.rootStore.wallSettingsStore.subjectType);
    return this.chosenSubjects.filter(subject => subject.subjectType.subjectType == this.rootStore.wallSettingsStore.subjectType);
  }

  get allSubjectsByType():ISubject[] {
    return this.subjects.filter(subject => subject.subjectType.subjectType == this.rootStore.wallSettingsStore.subjectType);
  }

}